import React, { Component } from 'react';
import classNames from 'classnames';
import NavBar from '../../containers/navBar';
// import SideBar from '../../containers/sideBar';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    root: {
        // width: '100%',
        
        height: 'calc(100% - 56px)',
        // marginTop: 56,
        [theme.breakpoints.up('sm')]: {
        //   height: 'calc(100% - 64px)',
        //   marginTop: 64,
        },
      },
      content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        // padding: theme.spacing.unit * 3,
        transition: theme.transitions.create('margin', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
      },
      'content-left': {
          height: '100%'
        // marginLeft: -constants.drawerWidth,
      },
      contentShift: {
        transition: theme.transitions.create('margin', {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
      'contentShift-left': {
        marginLeft: 30,
      },
})

class SidebarMenuRouters extends Component {
    constructor(props) {
        super(props);
    }
    
    state = {
        open: false
    }

    componentWillUpdate(nextProps) {
        if(nextProps.data.open !== this.props.data.open) {
            this.setState(nextProps.data);
        }
    }
    render() {
        const { classes, theme } = this.props;
        const {open} = this.state;

        return (
        //   <Router>
            <div className={classes.root}>
                <NavBar />
                {/* <SideBar /> */}
                <main
                    className={classNames(classes.content, classes[`content-left`], {
                        [classes.contentShift]: open,
                        [classes[`contentShift-left`]]: open,
                    })}
                >
                    {this.props.children}
                </main>
            </div>
        //   </Router>
        );
    }
}

export default withStyles(styles, { withTheme: true })(SidebarMenuRouters);